export function addEventById(event, elementId, callback) {
    const el = getElementById(elementId)
    if (el) {
        el.addEventListener(event, callback)
    }
}

export function addEventByClassName(event, elementsClassName, callback) {
    Array.from(document.getElementsByClassName(elementsClassName))
        .forEach(el => el.addEventListener(event, callback));
}

export function getElementById(elementId) {
    return document.getElementById(elementId)
}

export function getElementByClass(elementClass) {
    return document.getElementsByClassName(elementClass)
}

export function getElementByAttr(attrKey, attrValue) {
    let elements = document.querySelectorAll('[' + attrKey + '="' + attrValue + '"]')
    if (elements && elements[0]) {
        return elements[0]
    }

    return null
}

export function getValueById(elementId, defaultValue = null) {
    let element = document.getElementById(elementId)
    if (element) {
        return element.value
    }

    return defaultValue
}
